module.exports = __webpack_public_path__ + "img/pump-3.43a68cae.png";